// Product
export const setProductLoaded = ({ commit }, isLoaded) => { commit('SET_PRODUCT_LOADED', isLoaded) }
export const setProductName = ({ commit }, name) => { commit('SET_PRODUCT_NAME', name) }
export const setProductPrice = ({ commit }, price) => { commit('SET_PRODUCT_PRICE', price) }

// Header
export const setHeaderAlignment = ({ commit }, alignment) => { commit('SET_HEADER_ALIGNMENT', alignment) }
export const setProductNameEnabled = ({ commit }, isEnabled) => { commit('SET_PRODUCT_NAME_ENABLED', isEnabled) }
export const setProductPriceEnabled = ({ commit }, isEnabled) => { commit('SET_PRODUCT_PRICE_ENABLED', isEnabled) }

// Gamepad
export const setGamepadButtonsColor = ({ commit }, color) => { commit('SET_GAMEPAD_BUTTONS_COLOR', color) }
export const setArButtonEnabled = ({ commit }, isEnabled) => { commit('SET_AR_BUTTON_ENABLED', isEnabled) }
export const setResetButtonEnabled = ({ commit }, isEnabled) => { commit('SET_RESET_BUTTON_ENABLED', isEnabled) }
export const setDimensionsButtonEnabled = ({ commit }, isEnabled) => { commit('SET_DIMENSIONS_BUTTON_ENABLED', isEnabled) }
export const setScreenshotButtonEnabled = ({ commit }, isEnabled) => { commit('SET_SCREENSHOT_BUTTON_ENABLED', isEnabled) }

// AR
export const setArLoading = ({ commit }, isLoading) => { commit('SET_AR_LOADING', isLoading) }

// Glances
export const setGlancedOptionsItem = ({ commit }, item) => { commit('SET_GLANCED_OPTIONS_ITEM', item) }

// Error
export const setErrorDisplayed = ({ commit }, isDisplayed) => { commit('SET_ERROR_DISPLAYED', isDisplayed) }
export const error = ({ commit }, message) => {
  commit('SET_ERROR_MESSAGE', message)
  commit('SET_ERROR_DISPLAYED', true)
}
